module.exports = __webpack_public_path__ + "img/changeFineness-2.28a78a6.jpg";